/**
 * Security Logger - Log de eventos de segurança
 * Não loga informações sensíveis
 */

import type { SecurityEvent, SecurityLogEntry } from '../types/security';

class SecurityLogger {
  private static instance: SecurityLogger;
  private logs: SecurityLogEntry[] = [];
  private readonly MAX_LOGS = 100;

  private constructor() {}

  static getInstance(): SecurityLogger {
    if (!SecurityLogger.instance) {
      SecurityLogger.instance = new SecurityLogger();
    }
    return SecurityLogger.instance;
  }

  log(event: SecurityEvent, details?: Record<string, unknown>): SecurityLogEntry {
    const entry: SecurityLogEntry = {
      event,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      url: window.location.href,
      details: this.sanitizeDetails(details),
    };

    this.logs.push(entry);

    // Manter apenas os últimos MAX_LOGS
    if (this.logs.length > this.MAX_LOGS) {
      this.logs.shift();
    }

    // Mantém visibilidade local durante o desenvolvimento.
    if (process.env.NODE_ENV !== 'test' && process.env.NODE_ENV !== 'production') {
      console.info('[Security Event]', entry);
    }

    return entry;
  }

  private sanitizeDetails(details?: Record<string, unknown>): Record<string, unknown> | undefined {
    if (!details) return undefined;

    // Remove informações sensíveis
    const sanitized = { ...details };
    const sensitiveKeys = ['password', 'token', 'secret', 'apiKey', 'authorization'];
    
    for (const key of Object.keys(sanitized)) {
      if (sensitiveKeys.some(sensitive => key.toLowerCase().includes(sensitive))) {
        sanitized[key] = '[REDACTED]';
      }
    }

    return sanitized;
  }

  getLogs(): SecurityLogEntry[] {
    return [...this.logs];
  }

  clearLogs(): void {
    this.logs = [];
  }
}

export const securityLogger = SecurityLogger.getInstance();
